import { socket } from '@app'
import { useEffect } from 'react'

export default function useSocket<T> (eventName: string, eventHandler: (...args: T[]) => void) {
  useEffect(() => {
    socket.on(eventName, eventHandler)

    return () => {
      socket.off(eventName, eventHandler)
    }
  }, [])
}
